import React from "react";
import { LoginForm } from "../../components/Auth/LoginForm";
import Logo from "../../assets/logoEchari.png";
import "./Auth.scss";

export function Auth() {
  return (
    <div className="auth">
      <div className="containerLogoLogin">
        <img src={Logo} alt="Logo" className="logo" />
      </div>

      <div className="containerLoginForm">
        <LoginForm />
      </div>
    </div>
  );
}
